import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Logger } from './logger.service';
import { Util } from '../util';

export const isDevMode = !environment.production || Util.getOrigin().includes('test-developer');
const noop = (): any => undefined;

@Injectable({
  providedIn: 'root',
})
export class ConsoleLoggerService implements Logger {
  private masterSwitch: boolean;

  constructor() {}

  get info() {
    if (this.masterSwitch || isDevMode) {
      return console.info.bind(console);
    } else {
      return noop;
    }
  }

  get warn() {
    if (this.masterSwitch || isDevMode) {
      return console.warn.bind(console);
    } else {
      return noop;
    }
  }

  get error() {
    if (this.masterSwitch || isDevMode) {
      return console.error.bind(console);
    } else {
      return noop;
    }
  }

  invokeConsoleMethod(type: string, args?: any): void {
    const logFn: Function = console[type] || console.log || noop;
    logFn.apply(console, [args]);
  }

  switch(): void {
    this.masterSwitch = !this.masterSwitch;
    this.info('Master switch: ' + this.masterSwitch);
  }
}
